module.exports = __webpack_public_path__ + "img/ltktopshared-3x.61f69f9.jpg";